/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { MutableRef } from 'preact/hooks';

export type ReorderableContextProps<K extends string | number> = {
  currentItemKey: MutableRef<K | undefined>;
};
/**
 * Context used to pass reordering information.
 * We want to communicate information down to ReorderableItem.
 */
type K = string | number;
const ReorderableContext = createContext<ReorderableContextProps<K>>(null!);

export { ReorderableContext };
